import Collection from './generic/collection'
import { FetchData } from './utils/fetchData'
import Preloader from './preloader'
import CatalogFilter from "./catalogFilter";

class Pagination {
    constructor(instance) {
        this.instance = instance
        this.bindEvents()
    }

    updateUrl(query) {
        history.pushState(null, '', `?${ query }`);
    }

    handlePaginationClick = async (evt) => {
        evt.preventDefault();

        const url = evt.target.href;
        const response = await FetchData.getData(url)

        if (response?.query) {
            this.updateUrl(response.query);
        }

        CatalogFilter.insertDataFromQuery(response)
        Preloader.hide()
    }

    bindEvents() {
        this.instance
            .querySelectorAll('[data-js-pagination-page]')
            .forEach((link) => {
                link.addEventListener('click', this.handlePaginationClick)
            })
    }
}

export class PaginationCollection extends Collection {
    static selectors = {
        instance: '[data-js-pagination-search-result]',
    }

    constructor() {
        super(PaginationCollection.selectors.instance, Pagination)
    }
}
